var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUncheckLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.625H5.25C4.76875 16.625 4.375 16.2312 4.375 15.75V5.25C4.375 4.76875 4.76875 4.375 5.25 4.375H15.75C16.2312 4.375 16.625 4.76875 16.625 5.25V15.75C16.625 16.2312 16.2312 16.625 15.75 16.625ZM16.625 2.625H4.375C3.4125 2.625 2.625 3.4125 2.625 4.375V16.625C2.625 17.5875 3.4125 18.375 4.375 18.375H16.625C17.5875 18.375 18.375 17.5875 18.375 16.625V4.375C18.375 3.4125 17.5875 2.625 16.625 2.625Z",
    fill: "#003340",
    fillOpacity: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckLight);
export default __webpack_public_path__ + "static/media/uncheck-light.c18a46892903eb0d61238d17626a5c14.svg";
export { ForwardRef as ReactComponent };